import { defineMessages } from 'components/i18n';

export const bankAccountTypes = defineMessages({
  checking_account: {
    id: 'bank.bankAccount.types.checking_account',
    description: 'The name of a bank account with type: checking_account.',
    defaultMessage: 'Checking account',
  },
  savings_account: {
    id: 'bank.bankAccount.types.savings_account',
    description: 'The name of a bank account with type: savings_account.',
    defaultMessage: 'Savings account',
  },
  credit_card: {
    id: 'bank.bankAccount.types.credit_card',
    description: 'The name of a bank account with type: credit_card.',
    defaultMessage: 'Creditcard',
  },
  sepa_account: {
    id: 'bank.bankAccount.types.sepa_account',
    description: 'The name of a bank account with type: sepa_account.',
    defaultMessage: 'SEPA account',

  }
});

export const klarnaConnectionStatus = defineMessages({
  ACTIVE: {
    id: 'bank.klarnaConnection.status.active',
    description: 'The status when the bank connection is active.',
    defaultMessage: 'Active',
  },
  EXPIRED: {
    id: 'bank.klarnaConnection.status.expired',
    description: 'The status when the bank connection is expired.',
    defaultMessage: 'Expired',
  },
  REVOKED: {
    id: 'bank.klarnaConnection.status.revoked',
    description: 'The status when the bank connection is revoked.',
    defaultMessage: 'Revoked',
  },
  PENDING: {
    id: 'bank.klarnaConnection.status.pending',
    description: 'The status when the bank connection is pending.',
    defaultMessage: 'Pending',
  }
});

export const status: {[key: string]: any} = defineMessages({
  'active': {
    id: 'bank.bankAccount.status.active',
    defaultMessage: 'Active'
  },
  'inactive': {
    id: 'bank.bankAccount.status.inactive',
    defaultMessage: 'Inactive'
  },
});
